import Styles from './credit-card.module.scss';
interface Props {
  title: string;
  description: string;
  className?: string;
}

const PaymentBalanceError: React.FC<Props> = ({
  title,
  description,
  className = '',
}) => (
  <div className={`info ${Styles.alertMessage} ${className}`}>
    <h3>{title}</h3>
    {description && <p>{description}</p>}
  </div>
);

export default PaymentBalanceError;
